import React from "react";

const Splash = () => {
  return <div className="splash-container"><div className="spinner"></div></div>;
};

export default Splash;
